module.exports = __webpack_public_path__ + "static/media/pm_circular_workflow.43f0103c.svg";